import classnames from 'classnames';

import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import style from './styles.module.less';

type ActionsGroupProps = {
  value: boolean | null;
  onClick: (value: boolean) => void;
  isDisabled?: boolean;
  label: string;
  acceptButtonText: string;
  rejectButtonText: string;
};

export function ActionsGroup({ value, onClick, isDisabled, label, acceptButtonText, rejectButtonText }: ActionsGroupProps) {
  return (
    <FlexColumn className={style.container} gap={Gap.Space4}>
      <Text textType='Label' value={label} />
      <FlexRow className={style.buttonGroup} gap={Gap.Space8}>
        <Button
          className={classnames(style.button, { [style.selected]: value === true })}
          disabled={isDisabled}
          onClick={() => onClick(true)}
          theme='secondary'
        >
          {acceptButtonText}
        </Button>
        <Button
          className={classnames(style.button, { [style.selected]: value === false })}
          disabled={isDisabled}
          onClick={() => onClick(false)}
          theme='tertiary'
        >
          {rejectButtonText}
        </Button>
      </FlexRow>
    </FlexColumn>
  );
}
